/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class SpecimenTypeEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            example: {
                name: 'Nasopharyngeal Swab',
                code: 'NPS'
            }
        }
    }

    componentDidMount() {

        if(this.props.params.id) {
            this.fillItem('/api/specimentype/get/' + this.props.params.id, 'item');
        }
    }

    change = () => {
        this.setState({ item: {...this.state.item} });
    }

    submit = async (e) => {
        try
        {
            e?.preventDefault();
            var j = await qreq.postAsync('/api/specimentype/save', this.state.item);
            if(j.errorCode === 0) {
                this.success('Specimen type saved');
                this.goBack();
            }
            else
                this.alert(j.errorMessage);
        }
        catch(e)
        {
            this.unkownErrorCallback();
        }
    }

    render() {
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
            <h1>Specimen Type</h1>
            <Card title="Basic Information">
                <FormInput model={this.state.item} name="name" label="Name" required placeholder={this.state.example.name} onChange={this.change} />
                <FormInput model={this.state.item} name="code" label="Code" required placeholder={this.state.example.code} onChange={this.change} />
            </Card>
            <Card title="Settings">
                <div className="row">
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="isDisabled" label="Disable" type="switch" onChange={this.change} />
                        <small>Disable the specimen type completely from use.</small>
                    </div>
                </div>
            </Card>
            <AppActions>
                <button type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> Save</button>
            </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(SpecimenTypeEdit);